import SvgClose from "@Components/CustomIcon/SvgClose"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import React from "react"
import { View, TouchableOpacity, ScrollView } from "react-native"
import Modal from "react-native-modal"
import styles from "./styles"
import { RFValue } from "react-native-responsive-fontsize"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"

const CustomBottomModal = (props) => {
    const {
        footer,
        open,
        toggleModal,
        title,
        children,
        backgroundColor,
        isSimplePopUp,
        fullScreen,
        permanent,
        disabled
    } = props

    return (
        <Modal
            propagateSwipe={true}
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            swipeDirection={permanent ? [] : ["left", "right", "down"]}
            //onDismiss={toggleModal}
            isVisible={open}
            onSwipeComplete={toggleModal}
            onBackButtonPress={!permanent ? toggleModal : null}
            onBackdropPress={() => false}
            style={styles.container}
        >
            <View
                style={{
                    ...styles.content,
                    backgroundColor: backgroundColor ?? baseColors.white,
                    paddingHorizontal: fullScreen ? 0 : 20,
                    paddingVertical: fullScreen ? 0 : 25
                }}
            >
                {!fullScreen && (
                    <TouchableOpacity disabled={disabled} onPress={() => toggleModal(false)} style={styles.closeIcon}>
                        {isSimplePopUp ? (
                            <OpenSansText style={{ color: "white", padding: 10 }} fontWeight="bold" fontSize={20}>
                                X
                            </OpenSansText>
                        ) : (
                            <SvgClose />
                        )}
                    </TouchableOpacity>
                )}

                {!isSimplePopUp && title && (
                    <BreeSerifText fontSize={RFValue(20)} style={styles.title}>
                        {title}
                    </BreeSerifText>
                )}
                <View style={styles.modalContent}>{children}</View>
                {footer && <View>{footer}</View>}
            </View>
        </Modal>
    )
}

export default CustomBottomModal
